import React, {Component} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import HeaderMenuComponent from "./HeaderMenuComponent";
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';

class HeaderComponent extends Component {
    render(){
        const { classes, theme } = this.props;

        return (
            <AppBar
                position="absolute"
                className={classNames(classes.appBar, this.props.drawer && classes.appBarShift)}
            >
                <Toolbar disableGutters={!this.props.drawer}>
                    <IconButton
                        color="inherit"
                        aria-label="Open drawer"
                        onClick={this.props.toggleDrawer}
                        className={classNames(classes.menuButton, this.props.drawer && classes.hide)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="title" color="inherit" className={classes.flex}>
                        {this.props.title}
                    </Typography>
                    <HeaderMenuComponent
                        userRole={this.props.login.userInfo.role}
                        push={this.props.push}
                        routerPath={this.props.routerPath} signOut={this.props.signOut} />
                </Toolbar>
            </AppBar>
        )
    }
}

export default HeaderComponent;


// WEBPACK FOOTER //
// ./src/components/HeaderComponent.js